import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";

// Firebase config
/*const firebaseConfig = {
    apiKey: "AIzaSyBeLnyb_QqIo9CuemqkMwA2JHnWXbqIQ5g",
    authDomain: "rapdis-33955.firebaseapp.com",
    projectId: "rapdis-33955",
    storageBucket: "rapdis-33955.appspot.com",
    messagingSenderId: "260669547608",
    appId: "1:260669547608:web:ff4678e0831ebbdc99162d",
    measurementId: "G-YNP7D5W2E5"
  };
*/
// Firebase config rapdis.com
const firebaseConfig = {
  apiKey: "AIzaSyDoxklDvlR8J9EypuZDBz1691hhTldW9Aw",
  authDomain: "rap-dis.firebaseapp.com",
  projectId: "rap-dis",
  storageBucket: "rap-dis.appspot.com",
  messagingSenderId: "216480057447",
  appId: "1:216480057447:web:51f96cbea5280c9d7decc2",
  measurementId: "G-LYNLBTC9RY",
};

// initialize firebase
const app = initializeApp(firebaseConfig);
const projectAuth = getAuth(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
}); //const projectAuth = firebase.auth()
const projectFirestore = getFirestore(app); //const projectFirestore = firebase.firestore()
const projectStorage = getStorage(app); // const projectStorage = firebase.storage()
const projectMessaging = getMessaging(app); // const projectMessaging = firebase.messaging()

// timestamp
//const timestamp = app.firestore.Timestamp
const timestamp = "";

export {
  projectFirestore,
  projectAuth,
  timestamp,
  projectStorage,
  projectMessaging,
};
